import { NavbarComponent } from './../components/headerComponents.jsx';
import { AboutComponent,  BenefitComponent, InquiryFormComponent, ContactDetailsComponent, FAQComponent } from './../components/contentComponents.jsx';
import { FooterComponent } from './../components/footerComponents.jsx';

function Landingpage() {
  return (
    <div id="page-top">
        <NavbarComponent />
        <AboutComponent />
        <BenefitComponent />
        <InquiryFormComponent />
        <ContactDetailsComponent />
        <FAQComponent />
        <FooterComponent />
    </div>
  );
}

export default Landingpage;
